// chart data
import TotalLineCardChart1 from './total-value-graph-1';
import TotalLineCardChart2 from './total-value-graph-2';
import TotalLineCardChart3 from './total-value-graph-3';

import MarketChartCardData from './market-sale-chart';
import RevenueChartCardData from './revenue-chart';

import SeoChartCardData4 from './seo-chart-4';
import SeoChartCardData5 from './seo-chart-5';
import SeoChartCardData6 from './seo-chart-6';
import SeoChartCardData7 from './seo-chart-7';
import SeoChartCardData8 from './seo-chart-8';
import SeoChartCardData9 from './seo-chart-9';

import SalesLineCardChart from './sale-chart-1';
import AnalyticsChartCardData from './percentage-chart';

import SeoChartCardData1 from './seo-chart-1';
import SeoChartCardData2 from './seo-chart-2';
import SeoChartCardData3 from './seo-chart-3';

import ConversionsChartCardData from './conversions-chart';
import SatisfactionChartCardData from './satisfaction-chart';

// ===========================|| WIDGET - CHART DATA OBJECT ||=========================== //

const chartData = {
    TotalLineCardChart1,
    TotalLineCardChart2,
    TotalLineCardChart3,
    MarketChartCardData,
    RevenueChartCardData,
    SeoChartCardData4,
    SeoChartCardData5,
    SeoChartCardData6,
    SeoChartCardData7,
    SeoChartCardData8,
    SeoChartCardData9,
    SalesLineCardChart,
    AnalyticsChartCardData,
    SeoChartCardData1,
    SeoChartCardData2,
    SeoChartCardData3,
    ConversionsChartCardData,
    SatisfactionChartCardData
};

export default chartData;
